import React from "react";
import classNames from "classnames/bind";
import s from "./ConfirmDialog.module.scss";
import { getMakeStyleClasses } from "../common/getMakeStyleClasses";
import { Button } from "@material-ui/core";
import { SECTION } from "../../constants/constants";

const ConfirmDialog = (props) => {
  const classes = getMakeStyleClasses(compClasses);
  const cx = classNames.bind(classes);
  return (
    <section className={cx(s.container, classes.secondaryTextColor)}>
      <div className={cx(s.sectionHeading, classes.primaryThemeColor)}>
        Confirm
      </div>
      <section className={cx(s.contentContainer, classes.secondaryTextColor)}>
        This will remove all your saved changes. You will not be able to recover
        your changes. Are You Sure ?
      </section>
      <div className={s.actionContainer}>
        <Button
          onClick={() => {
            props.onCancelClick(null);
            props.setPopOverData({
              currentTarget: null,
              content: "",
            });
          }}
          size="small"
          color="primary"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            props.setSnackBarData({
              open: true,
              message: SECTION.SWITCH_TO_DEFAULT_RESUME,
            });
            props.setPopOverData({
              currentTarget: null,
              content: "",
            });
            props.onSaveClick();
          }}
          variant="contained"
          size="small"
          color="primary"
        >
          Do It
        </Button>
      </div>
    </section>
  );
};

export default ConfirmDialog;

const compClasses = (theme) => ({});
